// Generated file - do not change manually!

/**
 * Different types of BusyIndicator.
 */
export enum BusyIndicatorSize {
  /**
   * large size
   */
  Large = 'Large',

  /**
   * medium size
   */
  Medium = 'Medium',

  /**
   * small size
   */
  Small = 'Small'
}
